export function getText(richTexts?: SanityRichText[]): string {
  if (!richTexts) {
    return '';
  }
  let text = '';

  for (const richText of richTexts) {
    if (richText.text) {
      text += richText.text;
    }
    const chunk = getText(richText.children);
    text += chunk;
  }

  return text;
}
